import { SnackbarMessageType } from '@kubit/web-ui-components/snackbar/types';
import { commonStyles } from '../commonStyles';
import { SnackbarVariant } from '../variants';
export const getSimpleStyles = (FOUNDATIONS, FONT) => {
    return {
        [SnackbarVariant.SIMPLE]: {
            [SnackbarMessageType.ERROR]: {
                ...commonStyles(FOUNDATIONS, FONT),
                container: {
                    ...commonStyles(FOUNDATIONS, FONT).container,
                    background_color: FOUNDATIONS.color_comp_feedback_snackbar_error_bg,
                    border_color: FOUNDATIONS.color_comp_feedback_snackbar_error_border,
                },
                icon: {
                    ...commonStyles(FOUNDATIONS, FONT).icon,
                    color: FOUNDATIONS.color_feedback_error_bg_50,
                },
            },
            [SnackbarMessageType.INFORMATIVE]: {
                ...commonStyles(FOUNDATIONS, FONT),
                container: {
                    ...commonStyles(FOUNDATIONS, FONT).container,
                    background_color: FOUNDATIONS.color_comp_feedback_snackbar_info_bg,
                    border_color: FOUNDATIONS.color_comp_feedback_snackbar_info_border,
                },
                icon: {
                    ...commonStyles(FOUNDATIONS, FONT).icon,
                    color: FOUNDATIONS.color_feedback_info_bg_100,
                },
            },
            [SnackbarMessageType.SUCCESS]: {
                ...commonStyles(FOUNDATIONS, FONT),
                container: {
                    ...commonStyles(FOUNDATIONS, FONT).container,
                    background_color: FOUNDATIONS.color_comp_feedback_snackbar_success_bg,
                    border_color: FOUNDATIONS.color_comp_feedback_snackbar_success_border,
                },
                icon: {
                    ...commonStyles(FOUNDATIONS, FONT).icon,
                    color: FOUNDATIONS.color_feedback_success_bg_50,
                },
            },
            [SnackbarMessageType.WARNING]: {
                ...commonStyles(FOUNDATIONS, FONT),
                container: {
                    ...commonStyles(FOUNDATIONS, FONT).container,
                    background_color: FOUNDATIONS.color_comp_feedback_snackbar_warning_bg,
                    border_color: FOUNDATIONS.color_comp_feedback_snackbar_warning_border,
                },
                icon: {
                    ...commonStyles(FOUNDATIONS, FONT).icon,
                    color: FOUNDATIONS.color_feedback_warning_bg_100,
                },
            },
        },
    };
};
//# sourceMappingURL=simple.js.map